import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard, NoChildOrganizationAccessGuard, NoWhitelabelAccessGuard } from '@app/guards';

import { ConfigurationsProfileComponent } from './configurations-profile/configurations-profile.component';
import { ConfigurationsAppearanceComponent } from './configurations-appearance/configurations-appearance.component';
import { ConfigurationsNotificationComponent } from './configurations-notification/configurations-notification.component';
import { ConfigurationsSecurityComponent } from './configurations-security/configurations-security.component';
import { ConfigurationsPlanComponent } from './configurations-plan/configurations-plan.component';
import { ConfigurationsApiComponent } from './configurations-api/configurations-api.component';
import { ConfigurationsOAuthClientsComponent } from './configurations-oauth-clients/configurations-oauth-clients.component';
import { ConfigurationsOrganizationComponent } from './configurations-organization/configurations-organization.component';
import { ConfigurationsOrganizationMembersComponent } from './configurations-organization-members/configurations-organization-members.component';
import { ConfigurationsOrganizationGroupsComponent } from './configurations-organization-groups/configurations-organization-groups.component';
import { ConfigurationsOrganizationEmailsComponent } from './configurations-organization-emails/configurations-organization-emails.component';
import { ConfigurationsWebhooksComponent } from './configurations-webhooks/configurations-webhooks.component';
import { ConfigurationsReferralsComponent } from './configurations-referrals/configurations-referrals.component';
import { ConfigurationsIndexComponent } from '@app/pages/configurations/configurations-index/configurations-index.component';
import { ConfigurationsStandaloneIndexComponent } from '@app/pages/configurations/configurations-standalone-index/configurations-standalone-index.component';
import { ConfigurationsWhitelabelComponent } from './configurations-whitelabel/configurations-whitelabel.component';

const routes: Routes = [
  {
    path: 'perfil',
    component: ConfigurationsIndexComponent,
    canActivate: [AuthenticationGuard],
    data: { reuse: false },
    children: [
      { path: '', component: ConfigurationsProfileComponent, data: { title: 'route.profile' } },
      { path: 'seguranca', component: ConfigurationsSecurityComponent, data: { title: 'route.security' } },
      { path: 'aparencia', component: ConfigurationsAppearanceComponent, canActivate: [NoWhitelabelAccessGuard], data: { title: 'route.appearance' } },
      { path: 'notificacoes', component: ConfigurationsNotificationComponent, data: { title: 'route.notifications' } },
      { path: 'planos', component: ConfigurationsPlanComponent, canActivate: [NoChildOrganizationAccessGuard, NoWhitelabelAccessGuard], data: { title: 'route.plans' } },
      { path: 'api', component: ConfigurationsApiComponent, data: { title: 'route.api' } },
      { path: 'aplicativos', component: ConfigurationsOAuthClientsComponent, data: { title: 'route.oauthClients' } },
      { path: 'organizacao', component: ConfigurationsOrganizationComponent, data: { title: 'route.organization' } },
      { path: 'membros', component: ConfigurationsOrganizationMembersComponent, data: { title: 'route.members' } },
      { path: 'grupos', component: ConfigurationsOrganizationGroupsComponent, data: { title: 'route.groups' } },
      { path: 'emails', component: ConfigurationsOrganizationEmailsComponent, data: { title: 'route.emails' } },
      { path: 'webhooks', component: ConfigurationsWebhooksComponent, data: { title: 'route.webhooks' } },
      { path: 'indicacoes', component: ConfigurationsReferralsComponent, data: { title: 'route.referrals' } },
      { path: 'personalizacao', component: ConfigurationsWhitelabelComponent, data: { title: 'route.customization' } }
    ]
  }
];

const standaloneRoutes: Routes = [
  {
    path: 'perfil',
    component: ConfigurationsStandaloneIndexComponent,
    data: { reuse: false },
    children: [{ path: 'editar', component: ConfigurationsProfileComponent, data: { title: 'route.profile' } }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), RouterModule.forChild(standaloneRoutes)],
  exports: [RouterModule]
})
export class ConfigurationRoutingModule {}
